import type { ReactNode } from 'react';

type PropertyGroupProps = {
  /** Grid items to display */
  children: ReactNode;
  /** Whether to add a bottom border separator */
  withBorder?: boolean;
};

/**
 * A 2-column grid layout for displaying property items grouped together, with an optional bottom border for separation.
 * Designed to be used with PropertyItem components for consistent styling of label-value pairs.
 *
 * Example usage:
 * ```tsx
 *   <PropertyGroup withBorder>
 *     <PropertyItem label="Diameter" value={0.5} />
 *     <PropertyItem label="Status" value="Active" />
 *   </PropertyGroup>
 * ```
 */
const PropertyGroup = ({ children, withBorder = false }: PropertyGroupProps) => (
  <div className={`grid grid-cols-2 gap-4 ${withBorder ? 'border-b border-b-border pb-6' : ''}`}>{children}</div>
);
PropertyGroup.displayName = 'PropertyGroup';

export { PropertyGroup };
